/**
 * Due to some top level accessing to `window.platformUI.auth`,
 * tests are difficult to write as they break from "platformUI.auth doesnt exist in window"
 *
 * This issue primarily stems from `util.js` re-exporting it as a variable.
 *
 * Since removing the export from utils might impact too many different pages,
 * an easier fix is to have utils import auth from this file instead and then re-export that,
 * which enables us to use `jest.mock("PlatformAuth")` to ignore the errors.
 *
 * Eventually we want this data to exist in the store so that it can update during the session,
 * which then we can remove the utils export and finally this file.
 *
 * @deprecated This data will eventually exist in the store.
 */
export const auth = window.platformUI.auth;
